import bowser from 'bowser';

// These are "browsers" and bots that are used for synthetic monitoring
const MONITORS = ['pingdom'];

const matchUserAgent = match => window.navigator.userAgent.toLowerCase().includes(match.toLowerCase());

export const IS_FIREFOX = matchUserAgent('firefox');

/**
 * Checks whether the current browser is one of the known synthetic monitors
 * @return {boolean}
 */
export function isMonitorBot() {
  return MONITORS.some(monitor => matchUserAgent(monitor));
}

/**
 * Checks whether the current browser is officially supported
 * @return {boolean}
 */
export function isValidBrowser() {
  const browser = bowser.getParser(window.navigator.userAgent);
  return browser.satisfies({
    desktop: {
      chrome: '>1',
    },
  });
}
